<div class="wrapper--spacing-horizontal">
  <app-mineral-legal-notice></app-mineral-legal-notice>
</div>

@if ((showTotals$ | async) !== true) {
  <app-mineral-overview></app-mineral-overview>
}
@if ((showTotals$ | async) === true) {
  <app-mineral-totals></app-mineral-totals>
}
